import { CONTACT_EMAIL } from '../config';
import useConfirmationSubmit from '../hooks/useConfirmationSubmit';
import '../CSS/pages.css';

function Contact() {
  const { handleSubmit, isSubmitting, submitError } = useConfirmationSubmit(
    'contact',
    'contact'
  );

  return (
    <main className="page contact-page">
      <section className="page-heading">
        <p className="eyebrow">Contact</p>
        <h1>Tell us what you drive and where you want to run.</h1>
        <p>
          Share your equipment type, preferred lanes, availability, and the best
          way to reach you. We will follow up with a dispatch proposal tailored
          to your operation.
        </p>
      </section>

      <section className="contact-layout">
        <form className="contact-form" onSubmit={handleSubmit}>
          <label>
            Name
            <input type="text" name="name" placeholder="Your name" />
          </label>
          <label>
            Email
            <input
              type="email"
              name="email"
              placeholder="you@example.com"
              autoComplete="email"
              required
            />
          </label>
          <label>
            Phone
            <input type="tel" name="phone" placeholder="(555) 000-0000" required />
          </label>
          <label>
            Message
            <textarea
              name="message"
              rows="5"
              placeholder="Equipment type, trailer, lanes, and dispatch needs"
              required
            />
          </label>
          <button type="submit" disabled={isSubmitting}>
            {isSubmitting ? 'Sending...' : 'Send message'}
          </button>
          {submitError && <p className="form-error">{submitError}</p>}
        </form>

        <aside className="contact-panel">
          <h2>Proposal details to include</h2>
          <p>
            The more specific you are, the faster we can shape a useful dispatch
            proposal.
          </p>
          <a className="contact-email" href={`mailto:${CONTACT_EMAIL}`}>
            {CONTACT_EMAIL}
          </a>
          <ul>
            <li>Equipment and trailer type</li>
            <li>Home base and preferred lanes</li>
            <li>Weekly availability</li>
            <li>Target rate or revenue goals</li>
          </ul>
        </aside>
      </section>
    </main>
  );
}

export default Contact;
